import { Box, Text } from '@chakra-ui/react';
import type { Msg } from '@halo/chat-sdk-react';
import { useIsMyMsg, useUserInfo } from '@/scripts/hooks';
import { MsgUserText } from '../../msg-parts';

export interface MsgMediaCallRejectedContentProps {
  message: Msg;
}

export const MsgMediaCallRejectedContent = memo(function MsgMediaCallRejectedContent({
  message,
}: MsgMediaCallRejectedContentProps) {
  const { t } = useTranslation();
  const { user } = useUserInfo(message.owner_id);
  const isMe = useIsMyMsg(message);

  return (
    <Box as="span" display="inline">
      {!isMe && (
        <MsgUserText userName={user?.name || ''} userId={user?.user_id} display="inline" />
      )}
      <Text as="span" color="fg.muted" px="0.5" display="inline">
        {isMe ? t('chat.youDeclinedACall') : t('chat.declinedACall')}
      </Text>
    </Box>
  );
});
